
import { TypedVue } from "@/store/types";
import { Component, Watch } from "vue-property-decorator";
import ToSModal from "@/components/admin/ToSModal.vue";
import adminService from "@/services/adminService";
import TopHeader from "@/components/admin/TopHeader.vue";

@Component({
  components: {
    ToSModal,
    TopHeader,
  },
})
export default class DashboardView extends TypedVue {
  modalVisible = false;
  loading = false;

  get showHeader(): boolean {
    return this.$route.meta?.header?.enabled ?? true;
  }

  @Watch("$route", { immediate: true })
  async checkTos(): Promise<void> {
    // Check if user has agreed to ToS. Runs on initial render (immediate) and
    // on every /admin/* route change, since DashboardView is the persistent
    // parent and does not remount when child routes swap.
    const u = await this.$auth.getUser();

    if (!u?.hasAcceptedTos() && !this.$route.meta?.ignoreTOS) {
      this.modalVisible = true;
    }
  }

  async onConfirm(): Promise<void> {
    this.loading = true;

    try {
      // Update user
      await adminService.updateCurrentUser({ acceptedTos: true });
      this.modalVisible = false;

      try {
        await this.$auth.getTokenSilently({ ignoreCache: true });
      } catch (e) {
        await this.$auth.loginWithRedirect({});
      }
    } finally {
      this.loading = false;
    }
  }
}
